// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleSettingsButton_deviceButton__k7c4A","icon":"ToggleSettingsButton_icon__M-nz+","deviceButtonWithLabel":"ToggleSettingsButton_deviceButtonWithLabel__cgSxW"};